import styled, { css } from 'styled-components';

import { mediaQuery } from '@catalyze/ui';

export const FormLine = styled.div`
    display: flex;
    justify-content: center;
    flex-flow: column;
    ${mediaQuery(
        2,
        css`
            flex-flow: row;
        `
    )}
`;

export const InputContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    ${mediaQuery(
        2,
        css`
            flex-flow: row;
        `
    )}
`;
